import { createContext, useContext, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { supabase } from './supabase'

const AuthCtx = createContext(null)

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    supabase.auth.getSession().then(({ data }) => {
      if (!mounted) return
      setSession(data.session)
      setLoading(false)
    })
    const { data: sub } = supabase.auth.onAuthStateChange((_evt, s) => setSession(s))
    return () => { mounted = false; sub.subscription.unsubscribe() }
  }, [])

  const value = {
    session,
    user: session?.user || null,
    loading,
    signOut: () => supabase.auth.signOut(),
  }
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>
}

export function useAuth() {
  const ctx = useContext(AuthCtx)
  if (!ctx) throw new Error('useAuth outside AuthProvider')
  return ctx
}

export function ProtectedRoute({ children }) {
  const { session, loading } = useAuth()
  const loc = useLocation()
  if (loading) return <div className="p-8 text-arise-muted">…</div>
  if (!session) return <Navigate to="/login" state={{ from: loc }} replace />
  return children
}
